export default "__VITE_ASSET__DWQo2F7q__"